import Builder from '@/views/builder/Builder.vue'
import BuilderAudience from '@/views/builder/BuilderAudience.vue'
import BuilderCclone from '@/views/builder/BuilderCclone.vue'

const route = [
    {
        path: '/:account_id/builder',
        name: 'builder',
        component: Builder,
        redirect: '/:account_id/builder/segment',
        children: [
            {
                path: 'segment',
                name: 'builder-segment',
                component: BuilderAudience
            },
            {
                path: 'cclone',
                name: 'builder-cclone',
                component: BuilderCclone
            }
        ]
    },
    // {
    //     path: '/:account_id',
    //     redirect: '/:account_id/builder/segment'
    // }
]

export default route
